export default __webpack_public_path__ + "static/media/gallery_02.eb28268f.jpg";